export default function(kcal) {
  return parseFloat(kcal)
    .toFixed(0);
}
